import React from 'react'
import {Panel, Item} from 'tm/employees/PrimaryPanel'
import {recordDisplay, showCategory, getCategoryIconName, getCategoryIconColor} from 'utils'
import {get, isNull} from 'lodash'
import {connect} from 'react-redux'
import {Wrap, TitleArea, Title, Timelinedate, Timeline, Ul, Li, SubPanelarea} from 'tm/employees/Parts'
import * as icons from 'jbc-front/components/icons'
import {EducationBackground} from 'jbc-front/components/icons'
import ShowMoreBtn from './ShowMoreBtn'

class EmploymentInfomation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpand: false,
    }
  }
  render() {
    const {employee, schoolTypes, userDisplaySetting} = this.props
    const icon_name = getCategoryIconName(userDisplaySetting, 'education_background')
    const color =
      (!isNull(getCategoryIconColor(userDisplaySetting, 'education_background')) &&
        getCategoryIconColor(userDisplaySetting, 'education_background')) ||
      '#3498db'
    const IconName = icons[icon_name]
    const style = {color: color}
    return (
      (showCategory(userDisplaySetting, 'education_background') &&
        employee.employee_education_background &&
        employee.employee_education_background.length > 0 && (
          <Panel>
            <Item>
              <Wrap>
                <TitleArea>
                  <Title>
                    {(!isNull(icon_name) && <IconName size={30} color={color} />) || (
                      <EducationBackground size={30} color={color} />
                    )}
                    <div style={style}>学歴</div>
                  </Title>
                </TitleArea>
                <SubPanelarea>
                  <Ul>
                    {employee.employee_education_background &&
                      (this.state.isExpand
                        ? employee.employee_education_background
                        : employee.employee_education_background.slice(0, 2)
                      ).map(
                        (education_background, index) =>
                          education_background && (
                            <Li key={index}>
                              <Timelinedate>
                                [{' '}
                                {recordDisplay.option(
                                  get(education_background, 'school_type_id'),
                                  schoolTypes.map((t) => ({value: t.id, label: t.name}))
                                )}{' '}
                                ] {recordDisplay(get(education_background, 'school_name'))}
                              </Timelinedate>
                              {get(education_background, 'department') && (
                                <Timeline>{recordDisplay(get(education_background, 'department'))}</Timeline>
                              )}
                            </Li>
                          )
                      )}
                  </Ul>
                  {employee.employee_education_background && employee.employee_education_background.length > 2 && (
                    <ShowMoreBtn
                      isExpand={this.state.isExpand}
                      onToggleClick={() => {
                        this.setState({isExpand: !this.state.isExpand})
                      }}
                    />
                  )}
                </SubPanelarea>
              </Wrap>
            </Item>
          </Panel>
        )) ||
      null
    )
  }
}

export default connect((state) => ({
  employee: state.employees.current.data,
  schoolTypes: state.master.schoolTypes,
}))(EmploymentInfomation)
